<template>
    <div class="drug-register-view view">
        <div class="panel" style=" width: 95.5vw; margin-bottom:25px">
            <div v-if="$store.state.user.role.permissions.includes('can_view_resident')">
                <div v-if="patient">
                    <div v-if="isErxChartExpired && patient" style="padding: 10px 25px 0 25px;">
                        <div style="background-color: #E04F39; color: white; padding: 15px; border-radius: 8px; text-align: center; font-weight: bold; font-size: 1.1em; border: 2px solid #c43c2a;">
                            <i class="pi pi-exclamation-triangle" style="margin-right: 10px; font-size: 1.2em;"></i>
                            <template v-if="$store.state.user.type == 'prescriber'">
                                {{ $resident({ capitalize: true }) }} Medication Chart has Expired. All Prescriptions are thus expired. Please perform a Chart Review to renew it.
                            </template>
                            <template v-else>
                                {{ $resident({ capitalize: true }) }} Medication Chart has Expired. All Prescriptions are thus expired. Please contact the Prescriber to renew it.
                            </template>
                        </div>
                    </div>
                    <!-- Informational, not an alert: transitional prescribing is a valid pathway and
                         nothing is blocked, so this is deliberately styled as a quiet info panel rather
                         than reusing the red/orange alert treatment of the chart-expiry banner above. -->
                    <div v-if="!patient.erx_chart && patient" style="padding: 10px 25px 0 25px;">
                        <div style="display: flex; align-items: flex-start; gap: 10px; background-color: #EAF2FB; color: #24405E; padding: 12px 15px; border-radius: 8px; text-align: left; font-weight: 500; font-size: 1em; line-height: 1.45; border: 1px solid #C5DCF5;">
                            <i class="pi pi-info-circle" style="color: #0870DC; font-size: 1.1em; line-height: 1.45; flex-shrink: 0;"></i>
                            <span>
                                This {{ $resident() }} is on <b>Transitional Prescribing</b>. Medications can be charted as normal. When their prescriber is set up and ready for ePrescribing, a Chart Review will move all their current medications across.
                            </span>
                        </div>
                    </div>
                    <div style="display: flex; align-items: flex-end; justify-content: flex-start; gap: 30px;">
                        <!-- RESIDENTIAL INFORMATION TITLE AND EDIT BUTTON -->
                        <div style="display: flex; align-items: flex-end">
                            <!-- style="text-align: left; margin: 0; margin-left: 10px;" -->
                            <h2  class="panel-header" v-if="patient.personal_information">{{ patient.personal_information.first_name }} {{ patient.personal_information.last_name }}</h2>
                            <h2  class="panel-header" v-else>{{ $resident({ capitalize: true }) }} Information</h2>
                            <p style="font-weight: 500; color: black; margin: 5px; font-size: 1em; cursor: pointer; margin-left: 1em" 
                                v-if="selectedTab == 'medications' && displayPrescription" @click="selectTab('medications'), displayPrescription = false">
                                &lt; Return to {{ $resident({ capitalize: true }) }} Profile
                            </p>
                        </div>
                        <!-- END RESIDENTIAL INFORMATION TITLE AND EDIT BUTTON -->
                        <!-- FILES, MEDICATIONS, PATIENT INFO, OBSERVATIONS, ADMINISTRATION, MEDICATION HISTORY TABS -->
                        <div class="parent-tabs-container" style="display: flex; align-items: flex-end">
                            <h3 class="tab" :class="selectedTab == 'medications' ? 'selected-tab' : ''"
                                @click="selectTab('medications')" v-if="$store.state.user.patient_admin_active || $store.state.user.type == 'prescriber' || $store.state.user.type == 'pharmacist'">Medications</h3>
                            <h3 class="tab" :class="selectedTab == 'patient_info' ? 'selected-tab' : ''"
                                @click="selectTab('patient_info')">{{ $resident({ capitalize: true }) }} Info</h3>
                                <h3 class="tab" :class="selectedTab == 'files' ? 'selected-tab' : ''"
                                @click="selectTab('files')">Files</h3>
                            <h3 class="tab" :class="selectedTab == 'nims' ? 'selected-tab' : ''"
                                @click="selectTab('nims')" v-if="$store.state.user.patient_admin_active || $store.state.user.type == 'prescriber'">NIMs</h3>
                            <!-- <h3 class="tab" :class="selectedTab == 'special_considerations' ? 'selected-tab' : ''"
                                @click="selectTab('special_considerations')" v-if="$store.state.user.patient_admin_active || $store.state.user.type == 'prescriber'">Special Cons.</h3> -->
                            <!-- <h3 class="tab" :class="selectedTab == 'observations' ? 'selected-tab': ''" @click="selectTab('observations')">OBSERVATIONS</h3> -->
                            <!-- <h3 class="tab" :class="selectedTab == 'administration' ? 'selected-tab': ''" @click="selectTab('administration')">ADMINISTRATION</h3> -->
                            <h3 class="tab" v-if="$store.state.user.role.permissions.includes('can_view_prescription') && ($store.state.user.patient_admin_active || $store.state.user.type == 'prescriber')" :class="selectedTab == 'medication_history' ? 'selected-tab' : ''"
                                @click="selectTab('medication_history')">Medication History</h3>
                        </div>
                        <!-- END MEDICATIONS, PATIENT INFO, OBSERVATIONS, ADMINISTRATION, MEDICATION HISTORY TABS -->
                    </div>
                    <PatientBanner 
                        v-if="selectedTab == 'medications'"
                        :patient="patient"
                        :ihi="ihiDetails"
                        :medicare="medicare"
                        :dva="dva"
                        :concession="concession"
                        style="margin-bottom: 10px;"
                    />
                    <div class="main-patient-container"
                        style="border-top-left-radius: 0px; width: 100%; display: grid;" :style="selectedTab != 'patient_info' ? {gridTemplateColumns: '250px 5fr'}:{gridTemplateColumns: '1fr'}">
                        <!-- GENERAL INFO -->
                        <div class="general-patient" v-if="selectedTab != 'patient_info'"
                            style="grid-area: initial; padding: 0 25px; border-top-left-radius: 8px; border-bottom-left-radius: 8px; display: flex;">
                            <div style="width: 220px; margin-right: 10px;">
                                <h2 :style="patient.personal_information?.similar_sounding_name ? 'padding-top: 25px; margin: 0; color: #0870DC; font-size: 1.2em; text-align: left' : 'padding-top: 25px; padding-bottom: 12px; margin: 0; color: #0870DC; font-size: 1.2em; text-align: left'">
                                    {{ patient.personal_information.first_name }} {{ patient.personal_information.last_name }}</h2>

                                
                                <!-- <div>
                                    <div class="general-patient-info">
                                        <p class="general-patient-info-key">DOB</p>
                                        <p class="general-patient-info-value">{{ patient.personal_information.dob }}</p>
                                    </div>
                                    <div class="general-patient-info">
                                        <p class="general-patient-info-key">Age</p>
                                        <p class="general-patient-info-value">{{ patient.personal_information.age }}</p>
                                    </div>
                                    <div class="general-patient-info" v-if="medicare">
                                        <p class="general-patient-info-key">{{ medicare.regulatory_type }}</p>
                                        <p class="general-patient-info-value">{{ medicare.data }}</p>
                                    </div>
                                    <div class="general-patient-info" v-if="dva">
                                        <p class="general-patient-info-key">{{ dva.regulatory_type }}</p>
                                        <p class="general-patient-info-value">{{ dva.data }}</p>
                                    </div>
                                </div> -->

                                
             
                                <img class="img-square" :src="patient.image_information.url" :alt="$resident({ capitalize: true }) + ' Image'" v-if="patient.image_information && patient.image_information.created_at" onerror="this.onerror=null; this.className='img-square resident-image-default'"/>
                                <img v-else class="img-square resident-image-default" id="residentImage" :alt="$resident({ capitalize: true }) + ' Image'">
                                <div v-if="patient.image_information && patient.image_information.created_at" style="margin-top: 10px; text-align: center; color: #666; font-size: 0.9em; font-weight: 500;">
                                 <p style="margin: 0;">Updated: {{ patient.image_information.created_at }}</p>  
                                </div>
                                <p style="margin: 0 auto; width: 100%; padding: 4.7px 0; margin-bottom: 12px; border-radius: 4px; font-weight: bold; color: white" v-if="patient.status" :style="patient.status == 'Inactive' ? {backgroundColor: '#E04F39', border: '1px solid #E04F39'}: patient.status == 'Onboarding' ? {backgroundColor: '#EF9600', border: '1px solid #EF9600'} : {backgroundColor: '#00AD50', border: '1px solid #00AD50'}">{{ patient.status[0].toUpperCase() + patient.status.slice(1).toLowerCase() }}</p>
                                
                                <Button class="black-button" 
                                style="width: 100%; margin: 0 auto; margin-bottom: 12px; border-radius: 4px;  color: white; font-size: 0.9em; text-align: center; overflow: hidden; display: flex; align-items: center; justify-content: center;"
                                @click="viewFMhrFile">
                                <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26 13.0711C24.809 14.1963 23.6139 15.3182 22.4294 16.4494C22.2036 16.665 21.9883 16.8606 21.6337 16.8027C21.5248 16.7103 21.5581 16.5866 21.5581 16.4741C21.5551 15.573 21.5576 14.6714 21.5546 13.7702C21.5546 13.6731 21.5989 13.5369 21.4939 13.4911C21.3845 13.4435 21.3149 13.5756 21.2353 13.6353C20.8325 13.9373 20.5426 14.3456 20.1522 14.6588C20.0065 14.7754 19.8961 14.9411 19.6852 14.9738C19.6808 14.8753 19.5952 14.8291 19.5326 14.7703C19.0184 14.2854 18.5017 13.8033 17.987 13.3185C17.7199 13.0669 17.7174 12.8891 17.981 12.6413C19.1576 11.5357 20.3347 10.4316 21.5128 9.32788C21.7789 9.07867 21.9689 9.07914 22.2304 9.32414C23.3966 10.4176 24.5608 11.5124 25.73 12.6026C25.8374 12.7024 25.9035 12.8261 25.9995 12.9306V13.0706L26 13.0711Z" fill="#D3D3D3"/>
                                    <path d="M17.4514 20.9594C17.4514 20.9729 17.4514 20.9865 17.4494 20.9995H17.3002C17.0909 20.8614 16.9198 20.6841 16.7403 20.5156C15.6691 19.5122 14.5984 18.5079 13.5287 17.5032C13.2223 17.2152 13.2213 17.0636 13.5227 16.7807C14.6864 15.6883 15.8501 14.5962 17.0143 13.5042C17.3146 13.2223 17.4768 13.2251 17.7851 13.5112C18.3669 14.0507 18.9498 14.5892 19.5316 15.1282C19.5495 15.153 19.5515 15.1782 19.5381 15.2052C19.3929 15.4045 19.1979 15.4908 18.9393 15.4414C18.7628 15.4073 18.6141 15.4586 18.4868 15.5767C18.2043 15.8395 17.9248 16.1045 17.6424 16.3673C17.5081 16.4923 17.4703 16.6421 17.4708 16.813C17.4743 18.1267 17.4673 19.4399 17.4753 20.7536C17.4753 20.8231 17.4882 20.8936 17.4519 20.9594H17.4514Z" fill="#EE4120"/>
                                    <path d="M0.0407788 16.9021L0.0188975 16.9063L0 16.8956V13.444C0.0154164 13.444 0.0303355 13.4431 0.0452545 13.4403C0.141731 13.5252 0.128801 13.6381 0.129299 13.7445C0.132283 14.6966 0.132283 15.6481 0.129299 16.6001C0.129299 16.7061 0.142229 16.8199 0.0412761 16.9021H0.0407788Z" fill="#74AC8E"/>
                                    <path d="M4.12606 21C4.12705 20.9869 4.12705 20.9739 4.12606 20.9608C4.15092 20.9239 4.18971 20.9113 4.23248 20.9053C4.29116 20.9029 4.34487 20.9113 4.38117 20.9613C4.37919 20.9743 4.3772 20.9874 4.37471 21H4.12606Z" fill="#BCDB9A"/>
                                    <path d="M10.7934 10.9463C10.8918 10.9132 10.9505 10.8343 11.0202 10.7694C11.5483 10.2766 12.0734 9.78102 12.6016 9.28821C12.8458 9.06047 13.0357 9.05953 13.2829 9.29101C14.4724 10.404 15.661 11.5185 16.848 12.6343C17.1012 12.8723 17.0982 13.0506 16.8421 13.2909C15.6605 14.4007 14.4774 15.509 13.2948 16.6179C13.163 16.7411 13.0288 16.8592 12.8209 16.7602C12.8806 15.6131 12.8383 14.4651 12.8433 13.3175C12.8438 13.2013 12.8229 13.0856 12.7697 12.9782C12.7189 12.8434 12.617 12.743 12.5121 12.6432C11.9407 12.0967 11.3434 11.574 10.7909 11.0093C10.7805 10.9879 10.7814 10.9669 10.7934 10.9463Z" fill="#32A1DA"/>
                                    <path d="M4.38116 20.9608C4.32795 20.9566 4.27473 20.9524 4.22152 20.9482C4.17428 20.8348 4.20511 20.7177 4.20511 20.6024C4.20312 19.3769 4.19964 18.1514 4.2076 16.9259C4.20909 16.6837 4.13748 16.4933 3.94651 16.3271C3.67996 16.0952 3.42833 15.8479 3.17271 15.6052C3.04192 15.481 2.8987 15.4129 2.70674 15.4512C2.45908 15.5002 2.27011 15.4134 2.13832 15.2127C2.12489 15.187 2.1239 15.1604 2.13584 15.1338C2.71768 14.593 3.29952 14.0525 3.88137 13.5117C4.17726 13.2363 4.33789 13.2349 4.6308 13.5093C5.79598 14.6014 6.96067 15.6939 8.12535 16.7863C8.43616 17.078 8.43716 17.2185 8.13082 17.506C6.96663 18.5989 5.80195 19.6914 4.63727 20.7835C4.56218 20.8539 4.49603 20.9379 4.38215 20.9603L4.38116 20.9608Z" fill="#8BC440"/>
                                    <path d="M17.3848 10.3634C17.3848 9.72642 17.3892 9.0894 17.3818 8.45238C17.3793 8.25964 17.4429 8.1117 17.5921 7.97823C17.8915 7.71036 18.1844 7.43502 18.4699 7.15361C18.6041 7.02107 18.7553 6.95854 18.9363 7.01641C19.1537 7.08594 19.2949 7.00101 19.4396 6.8638C20.0448 6.28932 20.656 5.7195 21.2667 5.15015C21.3458 5.07642 21.4224 4.95695 21.5541 5.01575C21.671 5.06755 21.6292 5.19449 21.6292 5.29156C21.6312 6.30939 21.6277 7.32675 21.6322 8.34458C21.6337 8.65025 21.5203 8.90366 21.2926 9.1174C20.1035 10.2318 18.915 11.3472 17.7254 12.4612C17.6573 12.5251 17.5906 12.6254 17.4797 12.5872C17.3519 12.5428 17.3867 12.4178 17.3862 12.3216C17.3838 11.6692 17.3848 11.0163 17.3848 10.3639V10.3634Z" fill="#F6931E"/>
                                    <path d="M8.45057 16.7093C8.371 16.6417 8.28845 16.5773 8.21236 16.5063C7.08697 15.4521 5.96207 14.3969 4.83816 13.3409C4.76257 13.2699 4.69544 13.191 4.62482 13.1154C4.52238 12.9278 4.58305 12.7696 4.72876 12.6306C5.26833 12.1153 5.81487 11.6062 6.3609 11.0971C6.45788 11.0065 6.5643 10.9641 6.69559 11.0289C6.83533 11.098 6.98054 11.0971 7.13123 11.0681C7.24958 11.0453 7.37093 11.0565 7.46243 11.1302C7.88116 11.4676 8.26657 11.8367 8.62463 12.232C8.58136 12.1653 8.58235 12.0859 8.58235 12.0066C8.58235 11.1988 8.58186 10.391 8.58285 9.58268C8.58285 9.49774 8.5744 9.40861 8.62313 9.33207C8.66988 9.2588 8.71265 9.28587 8.74597 9.34747C8.77382 9.41421 8.7773 9.48421 8.7773 9.55375C8.77929 10.523 8.78128 11.4923 8.7763 12.4616C8.7763 12.5237 8.77034 12.5858 8.75741 12.6469C8.70469 12.7902 8.72757 12.9376 8.72757 13.0846C8.73005 14.1701 8.73005 15.2556 8.72757 16.3407C8.72757 16.4261 8.72757 16.5124 8.69325 16.5931C8.64949 16.6981 8.58484 16.7705 8.44958 16.7093H8.45057Z" fill="#BEBEBE"/>
                                    <path d="M8.69093 9.29147C8.62031 9.37361 8.65214 9.47068 8.65164 9.56075C8.64915 10.4806 8.65015 11.4009 8.65015 12.3375C8.28761 11.9287 7.88082 11.5913 7.50337 11.2282C7.39098 11.1204 7.2572 11.0863 7.09558 11.1372C6.94987 11.1829 6.79571 11.1811 6.67088 11.0854C6.5759 11.0126 6.51771 11.035 6.44163 11.1064C5.88216 11.6347 5.3217 12.162 4.75776 12.6861C4.62498 12.8098 4.61305 12.9572 4.62498 13.1154C4.45242 12.9241 4.37782 12.6982 4.37732 12.4528C4.37484 11.4368 4.37633 10.4208 4.37583 9.40534C4.37583 9.30407 4.35992 9.18694 4.47629 9.1384C4.60907 9.08333 4.68615 9.1944 4.76472 9.26767C5.3217 9.78709 5.87968 10.3051 6.4287 10.832C6.54805 10.9463 6.6132 10.9552 6.73703 10.8352C7.27312 10.3186 7.82313 9.81462 8.36271 9.30081C8.4751 9.19347 8.58948 9.12347 8.75408 9.1566C8.77398 9.21867 8.7506 9.26254 8.69043 9.29147H8.69093Z" fill="#D3D3D3"/>
                                    <path d="M8.45065 16.7093C8.66399 16.7075 8.64808 16.5586 8.64858 16.4289C8.65057 15.5538 8.64957 14.6788 8.64957 13.8038C8.64957 13.4939 8.64808 13.1845 8.65057 12.8746C8.65106 12.7995 8.6252 12.7183 8.69085 12.653C8.81119 12.7421 8.80125 12.8933 8.88181 13.0016C8.93254 13.1019 9.01807 13.1756 9.09963 13.2526C9.61931 13.7403 10.1395 14.2275 10.6582 14.7157C10.7278 14.781 10.8069 14.8394 10.8521 14.9252C10.8586 14.9486 10.8521 14.9682 10.8342 14.9845C10.2355 15.5394 9.63721 16.0947 9.03697 16.6482C8.8286 16.8405 8.68637 16.8531 8.45065 16.7098V16.7093Z" fill="#D3D3D3"/>
                                    <path d="M8.84461 13.03C8.74515 12.9218 8.72128 12.786 8.69095 12.653C8.69095 11.5325 8.69095 10.412 8.69095 9.29194C8.71233 9.24714 8.73322 9.20187 8.7546 9.15707C8.89136 9.13653 8.96446 9.22894 9.04503 9.30454C9.62836 9.85149 10.2107 10.3989 10.794 10.9463C10.7945 10.9575 10.7955 10.9692 10.7965 10.9804C10.8025 11.0989 10.7005 11.154 10.6284 11.2226C10.2062 11.623 9.78203 12.0225 9.35435 12.4182C9.15593 12.6021 8.95452 12.7813 8.84561 13.03H8.84461Z" fill="#5080A6"/>
                                    <path d="M19.531 15.1684C19.532 15.1553 19.5325 15.1418 19.5315 15.1287C19.5827 15.0774 19.6339 15.026 19.6846 14.9747C20.2178 14.4791 20.7504 13.983 21.285 13.4888C21.3586 13.4207 21.4292 13.3115 21.552 13.3675C21.6569 13.4155 21.6281 13.5299 21.6281 13.6204C21.6306 14.6812 21.6321 15.7419 21.6336 16.8027C21.6162 16.8652 21.6336 16.9371 21.5764 16.9889C21.4943 17.0477 21.4322 16.995 21.3814 16.9478C20.7688 16.3803 20.1536 15.8157 19.5583 15.2318C19.5414 15.215 19.535 15.1912 19.531 15.1679V15.1684Z" fill="#A12426"/>
                                    <path d="M10.8343 14.984C10.8323 14.97 10.8293 14.9565 10.8259 14.9425C10.8507 14.8454 10.9353 14.7899 11.0044 14.725C11.4291 14.3241 11.8543 13.9237 12.2825 13.5261C12.4868 13.3367 12.7017 13.1565 12.7788 12.8812C12.8956 13.0132 12.9275 13.1691 12.9275 13.3353C12.9275 14.3895 12.9275 15.4437 12.9275 16.4975C12.9275 16.5969 12.9473 16.7042 12.8215 16.7597C12.6907 16.7485 12.6276 16.6468 12.5475 16.5731C11.9751 16.0448 11.4057 15.5137 10.8353 14.9836L10.8343 14.984Z" fill="#1F6DB0"/>
                                    <path d="M2.13532 15.1343C2.13184 15.1469 2.13135 15.159 2.13334 15.1716C2.11991 15.2556 2.05078 15.3042 1.99359 15.3583C1.44954 15.8703 0.905495 16.3817 0.359457 16.8909C0.283867 16.9614 0.21126 17.0402 0.0924051 17.0472C0.0411829 17.009 0.0531181 16.9516 0.0411829 16.9016C0.0426748 15.7475 0.0441667 14.5939 0.0456586 13.4398C0.160038 13.2643 0.257012 13.3927 0.336083 13.4655C0.726466 13.8234 1.10939 14.1888 1.49729 14.55C1.70814 14.7465 1.92298 14.9397 2.13582 15.1343H2.13532Z" fill="#006630"/>
                                    <path d="M19.5311 15.1684C20.1328 15.671 20.6729 16.2324 21.2537 16.7546C21.3517 16.8424 21.4193 16.9716 21.5765 16.9894C21.5476 17.1821 21.4372 17.3319 21.295 17.4654C20.104 18.5821 18.9129 19.6989 17.7224 20.8161C17.6458 20.888 17.5712 20.9608 17.4514 20.9599C17.3897 20.8693 17.3957 20.7681 17.3957 20.6668C17.3957 19.3694 17.3986 18.0721 17.3932 16.7747C17.3922 16.5903 17.4479 16.448 17.5906 16.3201C17.89 16.0518 18.1799 15.7746 18.4698 15.4974C18.5827 15.3891 18.7225 15.313 18.8692 15.3639C19.1556 15.4624 19.3406 15.3233 19.5306 15.1693L19.5311 15.1684Z" fill="#B01020"/>
                                    <path d="M0.0920787 17.0477C0.699285 16.4839 1.30649 15.9197 1.91469 15.3564C1.98432 15.292 2.0604 15.2332 2.13351 15.1716C2.32944 15.362 2.54478 15.4656 2.83918 15.363C2.95406 15.3228 3.05899 15.4026 3.14452 15.4834C3.47175 15.7919 3.79897 16.1003 4.12819 16.4069C4.23511 16.5063 4.27837 16.6225 4.27837 16.763C4.27638 18.0763 4.27688 19.3895 4.27738 20.7023C4.27738 20.7886 4.27539 20.8731 4.22218 20.9487C4.19035 20.9524 4.15852 20.9566 4.1267 20.9603C4.02674 20.9305 3.96457 20.8558 3.89445 20.7905C2.73475 19.704 1.57553 18.6167 0.41632 17.5298C0.269118 17.3921 0.127387 17.2516 0.0920787 17.0477Z" fill="#005926"/>
                                    <path d="M12.7782 12.8816C12.7827 13.0076 12.7802 13.135 12.6773 13.2298C12.0596 13.8001 11.4713 14.3988 10.8258 14.9425C10.2037 14.3638 9.58055 13.7861 8.96091 13.2051C8.91018 13.1579 8.88283 13.0888 8.84454 13.03C8.8336 12.8606 8.92311 12.7402 9.04644 12.6254C9.63227 12.0794 10.2131 11.5292 10.7955 10.9804C11.4668 11.5544 12.0879 12.1756 12.7295 12.7776C12.7558 12.8023 12.7623 12.8466 12.7782 12.8816Z" fill="#18619A"/>
                                    </svg>
                                    <span style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 10px;">View My Health Record</span>
                                </Button>
                                <button class="daily-doses-button" @click="viewDailyDoses" 
                                :style="displayDailyDosesModal ? {color: 'white', backgroundColor: '#274188'}:{color: '#274188', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #274188; font-weight: bold; margin-bottom: 5px; padding: 5px 0; border-radius: 4px; cursor: pointer; font-size: 14.4px; font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;">Daily Doses</button>
                                <div style="margin-bottom: 12px; width: 100%;">
                                    <Dropdown 
                                        v-model="selectedAdhocReading" 
                                        :options="adhocReadingOptions" 
                                        optionLabel="label" 
                                        optionValue="value"
                                        placeholder="Add Clinical Reading..." 
                                        style="width: 100%; border: 2px solid #0870DC; font-weight: bold;" 
                                        @change="openAdhocReadingModal"
                                    />
                                </div>
                                <button class="daily-doses-button" @click.prevent="displayReadingsModal = true" 
                                :style="displayReadingsModal ? {color: 'white', backgroundColor: '#274188'}:{color: '#274188', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #274188; font-weight: bold; margin-bottom: 12px; padding: 5px 0; border-radius: 4px; cursor: pointer; font-size: 14.4px; font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;">View Clinical Readings</button>

                                <div style="margin-bottom: 12px; width: 100%; display: flex; flex-direction: column; align-items: flex-start;">
                                    <label style="font-weight: bold; font-size: 0.9em; margin-bottom: 4px; color: #274188;">Next INR test ordered on</label>
                                    <div class="p-inputgroup" style="width: 100%;">
                                        <Calendar 
                                            v-model="nextInrTestDate" 
                                            dateFormat="dd/mm/yy" 
                                            placeholder="Select Date" 
                                            :showIcon="false"
                                            style="width: 100%; line-height: 2;" 
                                            inputStyle="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                                        />
                                        <Button icon="pi pi-check" :loading="savingInrTestDate" @click="updateNextInrTestDate(nextInrTestDate)" style="border-top-left-radius: 0; border-bottom-left-radius: 0; margin-left: 5px; margin-top: -1px" />
                                    </div>
                                    <div v-if="patient.next_inr_test" style="font-size: 0.85em; margin-top: 4px; color: #555; font-weight: bold;">
                                        Next INR Test: {{ new Date(patient.next_inr_test).toLocaleDateString() }}
                                    </div>
                                </div>
                                <!-- <Button class="black-button" 
                                style="width: 100%; margin: 0 auto; padding: 4.7px 0; margin-bottom: 12px; border-radius: 4px; font-weight: bold; color: white; font-size: 0.9em; text-align: center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                label="Upload Resident Medication Chart"
                                @click="uploadFile" />                         -->
                        
                                <!-- <router-link v-if="this.$store.state.userType !='pharmacy' && !displayPrescription && $store.state.user.role.permissions.includes('can_do_resident')" style="text-decoration: none; margin: 0"
                                    :to="'/patient/' + $route.params.id + '/edit'">
                                    <p style="margin: 0 auto; width: 100%; padding: 4.7px 0; margin-bottom: 12px; border-radius: 4px; font-weight: bold; color: white; background-color: #EF9600"> <i
                                            class="pi-pencil pi" style="font-size: 0.9em !important"></i> Edit Resident</p>
                                </router-link> -->
                                <div style='background-color:white !important;'>
                                    <div :class="infoADRTab == 'INFO' ? 'info-tab-border': 'adr-tab-border'">
                                        <!-- PATIENT INFO/ADR TAB SELECT -->
                                        <div style="display: flex; justify-content: space-around; align-items: center;" :class="infoADRTab == 'INFO' ? 'info-tab-bottom': 'adr-tab-bottom'">
                                            <h4 style="cursor: pointer; width: 100%; margin: 0; padding: 5px 0; width: 50%;"
                                                @click="infoADRTab = 'INFO'"
                                                :class="infoADRTab == 'INFO' ? 'info-tab' : {}">
                                                INFO</h4>
                                            <h4 style="cursor: pointer; width: 50%; margin: 0; padding: 5px 0;"
                                                @click="infoADRTab = 'ADR'"
                                                :class="infoADRTab == 'ADR' ? 'adr-tab' : {}">
                                                ADR</h4>
                                        </div>
                                        <!-- PATIENT STICKERS -->
                                        <div style="height: 200px; overflow: scroll; cursor: pointer;" v-if="infoADRTab == 'ADR'" @click="displayADRModal = true">
                                            <table style="padding: 0 10px; border-collapse: collapse;" v-if="patient.adr && patient.adr.length">
                                                <tr>
                                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 0 10px;">Drug</th>
                                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 0 10px;">Year</th>
                                                </tr>
                                                <tr v-for="(item, index) in patient.adr" :key="index">
                                                    <td style="padding: 0 10px;">{{ item.drug ? item.drug.toUpperCase() : item.custom ? item.custom.toUpperCase() : 'Non Spec.'}}</td>
                                                    <td style="padding: 0 10px;">{{ item.date ? item.date.split(',')[1] : '----'}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <!-- PATIENT INFO -->
                                        <div
                                            style="height: 200px; text-align: left; overflow-x: auto; background-color: white !important; border-radius: 8px"
                                            v-if="infoADRTab == 'INFO'"
                                        >
                                            <div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">Sex:</p>
                                                    <p class="general-patient-info-value" >{{ patient.personal_information.sex }}</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">Preferred Name:</p>
                                                    <p class="general-patient-info-value" >
                                                        {{ patient.personal_information.preferred_name }}</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">DOB:</p>
                                                    <p class="general-patient-info-value" >{{ patient.personal_information.dob }}</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">Age:</p>
                                                    <p class="general-patient-info-value" >{{ patient.personal_information.age }}</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">Height:</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-if="patient.latest_height_reading?.value && patient.latest_height_reading.value != 0"
                                                    >{{ patient.latest_height_reading.value }} cm</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-else
                                                    >Unknown</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">Weight:</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-if="patient.latest_weight_reading?.value && patient.latest_weight_reading.value != 0"
                                                    >{{ patient.latest_weight_reading.value }} kg</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-else
                                                    >Unknown</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important" v-for="(item, index) in patient.contact_methods"
                                                    :key="index">
                                                    <p class="general-patient-info-key">{{ item.type.charAt(0).toUpperCase() + item.type.slice(1) }}:</p>
                                                    <p class="general-patient-info-value" >{{ item.data }}</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important"
                                                    v-for="(item, index) in patient.regulatory_information" :key="index">
                                                    <p class="general-patient-info-key">{{item.regulatory_type.charAt(0).toUpperCase() + item.regulatory_type.slice(1) }}:</p>
                                                    <p class="general-patient-info-value" >{{ item.data }}</p>
                                                </div>
                                                <div class="general-patient-info" style="background-color: transparent !important">
                                                    <p class="general-patient-info-key">Address:</p>
                                                    <p class="general-patient-info-value" >{{facility?.address ? facility.address.street_address : 'N/A'}}{{facility?.address?.suburb ? ', ' : ''}}{{facility?.address?.suburb}}{{facility?.address?.state ? ', ' : '' }}{{facility?.address?.state}}{{facility?.address?.postcode ? ', ' : '' }}{{facility?.address?.postcode}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-bottom: 12px;">
                                    <div v-if="spec_cons && $store.state.user.patient_admin_active">
                                        <div
                                            v-if="spec_cons.special_considerations && spec_cons.special_considerations.length"
                                            style="display: flex; flex-wrap: wrap; padding: 5px; background-color: white; border-radius: 8px; margin-top: 2px; overflow: auto; max-height: 130px;"
                                        >
                                            <p
                                                class="field-value"
                                                v-for="(item, index) in uniqueSpecCons" :key="index"
                                                style="color: white; font-weight: bold; background-color: #E04F39; border-radius: 30px; height: fit-content; padding: 3px 20px; margin-top: 0px; margin-right: 5px;"
                                                :v-tooltip="' '+item.name+' '"
                                            >
                                                {{item.name.length > 15 ? item.name.slice(0,15).toUpperCase()+'...' : item.name.toUpperCase() }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="$store.state.user.patient_admin_active">
                                    <h4 style="font-weight: normal; text-align: left; margin: 0 ">Last Chart Review:</h4>
                                    <p style="margin: 0; text-align: left; font-size: 1em;"><b>{{patient.chart_review ? patient.chart_review.reviewed_on : 'N/A'}}</b></p>
                                    <h4 style="font-weight: normal; text-align: left; margin: 0; margin-top: 15px;">Next Chart Review: </h4>
                                    <p style="margin: 0; text-align: left; font-size: 1em;"><b>{{patient.chart_review ? patient.chart_review.next_review_date : 'N/A'}}</b></p>
                                </div>
                                <div style="  padding-bottom: 5px; padding-top: 5px; margin-top: 25px; min-width: 180px;">
                                    <p
                                            style="text-align: left; margin-bottom: 5px; font-size: 1em; font-weight: 500"
                                            >
                                            Chart Information
                                    </p>
                                    <div v-if="patient.erx_chart" :style="isErxChartExpired ? {backgroundColor: 'rgba(224, 79, 57, 0.2)'} : {backgroundColor: '#f9f9f9'}" style="justify-content: center;  padding-bottom: 5px; padding-top: 5px; text-align: center; min-width: 180px; border-radius: 6px; border: 1px solid #ddd;">
                                        <div style="padding-top: 5px;"><strong>Start Date:</strong> {{ patient.erx_chart.start_date ? patient.erx_chart.start_date : 'N/A'}}</div>
                                        <div style="padding-top: 5px;"><strong>End Date:</strong> {{ patient.erx_chart.end_date ? patient.erx_chart.end_date : 'N/A'}}</div>
                                        <div style="padding-top: 5px;"><strong>ID:</strong> {{ patient.erx_chart.uuid ? patient.erx_chart.uuid : 'N/A'}}</div>
                                        <div style="padding-top: 5px;"><strong>DSPID:</strong> {{ patient.erx_chart.scid ? patient.erx_chart.scid : 'N/A'}}</div>
                                        <div style="padding-top: 5px;"><strong>QR Code:</strong></div>
                                        <div v-html="patient.erx_chart.qr_code"></div>
                                        <br>
                                        <Button v-if="patient.erx_chart" :class="isErxChartExpired ? 'p-button-primary' : 'p-button-danger'" style="margin-top: 10px;" :style="isErxChartExpired ? { backgroundColor: '#0870DC', border: '1px solid #0870DC' } : { backgroundColor: '#E04F39', border: '1px solid #E04F39' }" :label="isErxChartExpired ? 'Chart Review' : 'Cancel Chart'" @click="isErxChartExpired ? startChartReview() : ceaseChart()" />
                                    </div> 
                                    <div v-else style=" padding-bottom: 5px; padding-top: 5px; text-align: center; min-width: 180px; background: #f9f9f9; border-radius: 6px; border: 1px solid #ddd;">
                                        <p>No eRx Chart Assigned</p>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- <hr style="border:none; border-left:2px solid #e8e8e8; height:90%; width:2px; align-self: center"> -->
                        </div>
                        <div style="background-color: white; border-radius: 12px; border-top-left-radius: 0px; border-top-right-radius: 0px;" :style="selectedTab == 'patient_info' ? {borderTopLeftRadius:'8px'}:{}">
                            <PatientMedicationTable
                                ref="medTable"
                                v-if="selectedTab == 'medications' && !displayPrescription && !refreshingPatientReadings"
                                @remapPresChart="remapPresChart"
                                @displayPrescriptionForm="displayPrescriptionForm"
                                @signChart='signChart'
                                @updateChartHeight="updateChartHeight"
                                @addingToReview="addingToReview"
                                @removingFromReview="removingFromReview"
                                @emptyReviewPrescription="emptyReviewPrescription"
                                @retrieveAllCharts="retrieveAllCharts"
                                @successfullySubmitted="getPatient"
                                @getAdministration="getAdministration"
                                @dismissExpiredChart="dismissExpiredChart"
                                @removeExpiredCharts="removeExpiredCharts"
                                @dismissAllCharts="dismissAllCharts"
                                :reviewedPrescriptions="reviewedPrescriptions"
                                :loadingCharts="loadingCharts"
                                :facility_id="patient && patient.physical_location && patient.physical_location.location && patient.physical_location.location.facility && patient.physical_location.location.facility.uuid ? patient.physical_location.location.facility.uuid : '' "
                                :charts="charts"
                                :expiredCharts="expiredCharts"
                                :patient="patient"
                                :patientId="$route.params.id"
                                :frequencies="frequencies"
                                :triggerUploadFile="triggerUploadFile"
                                :types="typeOptions"
                                :routes="routes"
                                :drugs="drugs"
                                :nextReviewDate="patient?.chart_review?.next_review_date ? new Date(patient.chart_review.next_review_date) : ''"
                                @patientConsentUpdated="handlePatientConsentUpdated"
                            />
                            <PatientInfo v-if="selectedTab == 'patient_info'" :patient="patient" @changeStatus="changeStatus" />
                            <Files v-if="selectedTab == 'files'" :patient="patient" @uploadFile="uploadFile" />
                            <MiniViewMhr v-if="openMhrMiniView" :patient="patient" @close="viewFMhrFile"/>
                            <div v-if="triggerUploadFile == true">openMhr
                                <MyHealthRecorModal :actionTitle="mhrSuccess ? 'Success' : 'Residential Medication Chart'" :uploadFile="uploadFileStatus" @action="uploadFileHandler"
                                :loading="loadingMhr" :errorMessage="mhrError" :supersedeFile="supersedeFile"
                                :actionDescription="mhrSuccess ? 'Residential Medication Chart uploaded successfully to My Health Record.' : ''"
                                :acceptText="mhrSuccess ? 'OK' : 'Confirm'" :hideCancel="mhrSuccess"
                                    @close="closeMhrModal" />
                            </div>
                            <PrescriberNIMSelect v-if="selectedTab == 'nims'" :patient="patient" />
                            <SpecialConsiderations v-if="selectedTab == 'special_considerations'" :spec_cons="spec_cons" />
                            <PatientMedicationHistory v-if="selectedTab == 'medication_history'" :patient="patient" />
                            <!-- Readings are re-fetched before the prescribing form opens (see
                            refreshPatientReadings) so the warfarin/INR panel cannot acknowledge a
                            superseded reading - hold the spinner until that lands. -->
                            <div v-if="selectedTab == 'medications' && refreshingPatientReadings" style="width: 100%; margin-top: 5em; text-align: center;">
                                <p style="font-size: 1em; font-weight: bold;">Confirming latest readings...</p>
                                <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;"></i>
                            </div>
                            <PrescriptionChart :displayDropDown="true" :patient="patient" :medicare="medicare" v-if="selectedTab == 'medications' && displayPrescription" :patientId="$route.params.id" :new="true" :forceNoErx="forceNoErx" @patientConsentUpdated="handlePatientConsentUpdated" />
                            <!-- <PrescriptionChart  v-if="selectedTab == 'medications' && displayPrescription" :viewOnly="false" @isSuccessful="isSuccessful" 
                            :patientId="$route.params.id" :activePresChart="activePresChart" :draftDrug="draftDrug" :isDraft="false"
                            :displayDropDown="true" /> -->
                        </div>
                    </div>
                </div>
                <div v-else class="panel-content-container patient-form" style="display: flex; width: 95vw; margin: 0 auto;">
                    <div style='width: 100%; margin-top: 5em;'>
                        <p style="font-size: 1em; font-weight: bold;">Loading {{ $resident({ capitalize: true }) }}...</p>
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;"></i>
                    </div>
                </div>
                <ChartExpansion v-if="displayExpansion" :chartId="displayedChartId"
                    :expandedChartDetails="expandedChartDetails" />
            </div>
            <div v-else class="panel-content-container">
                <div style="margin-top: 10em; grid-column: 1 / 3;">
                    <h3 style="border: 2px solid black; border-bottom: 2px solid black; width: fit-content; margin: 0 auto; padding: 5px; border-radius: 4px">
                        You do not have permission to access this feature. Please talk to your admin if you require access.
                    </h3>
                </div>
            </div>
        </div>
        <!-- <patient-expand-modal v-if="expandModal" @close="close" :modalTitle="modalTitle" :tableData="tableData" /> -->
        <ADRModal v-if="displayADRModal" :patient="patient" @close="displayADRModal = false" />
        <DailyDosesModal v-if="displayDailyDosesModal" :patient="patient" :dailyDoses="dailyDoses" :loadingDailyDoses="loadingDailyDoses" :isErxChartExpired="isErxChartExpired" @close="displayDailyDosesModal = false" />
        <AdhocReadingModal
            v-if="displayAdhocReadingModal"
            :readingType="selectedAdhocReading"
            :patientId="patient && patient.uuid ? patient.uuid : ''"
            @close="closeAdhocReadingModal"
            @readingCompleted="handleAdhocReadingCompleted"
        />
        <ReadingsModal
            v-if="displayReadingsModal"
            :patientId="patient && patient.uuid ? patient.uuid : ''"
            @close="displayReadingsModal = false"
        />
        <ConfirmationModal
            v-if="displayCeaseChartModal"
            :actionDescription="'Are you sure you want to cease this chart? This action cannot be undone.'"
            @close="displayCeaseChartModal = false"
            @accepted="confirmCeaseChart"
        />
        <SignatureModal
            v-if="displayCeaseSignatureModal"
            :payload="ceaseChartPayload"
            :endpoint="'/cease-chart'"
            :signatureType="'cancellation'"
            @close="handleCeaseChartSignatureClose"
            @error="handleCeaseChartSignatureError"
        />
        <!-- Cease Chart Reason Modal -->
        <div class="modal-mask" v-if="displayCeaseReasonModal">
            <div class="modal-wrapper">
                <div class="modal-container" style="width: 30%">
                    <div class="modal-header">
                        <h3 class="form-header">Cease Chart</h3>
                        <button @click="closeCeaseReasonModal" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 20px;">
                        <p style="font-size: 1.1em; margin-bottom: 10px;">
                            Please provide a reason for ceasing this chart (optional).
                        </p>
                        <textarea v-model="ceaseChartReason" rows="4" style="width: 100%;" placeholder="Reason for ceasing"></textarea>
                    </div>
                    <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px; gap: 10px;">
                        <button class="grey-button" @click="closeCeaseReasonModal">Back</button>
                        <button class="green-button" @click="confirmCeaseReason">Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import PrescriptionChart from '../../components/PrescriptionChart.vue';
import PatientInfo from '../../components/patientViewComponents/PatientInfo.vue';
import PatientBanner from '../../components/patientViewComponents/PatientBanner.vue';
import PatientMedicationTable from '../../components/tables/PatientMedicationTable.vue';
// import PatientExpandModal from '../../components/modals/PatientExpandModal.vue';
import PatientMedicationHistory from '../../components/patientViewComponents/PatientMedicationHistory.vue';
import PrescriberNIMSelect from '../../components/patientViewComponents/PrescriberNIMSelect.vue';
import Files from '../../components/patientViewComponents/Files.vue';
import SpecialConsiderations from '../../components/patientViewComponents/SpecialConsiderations.vue';
import ChartExpansion from '@/components/ChartExpansion.vue';
import MyHealthRecorModal from '../../components/modals/MyHealthRecorModal.vue';
import MiniViewMhr from '../../components/patientViewComponents/MiniViewMhr.vue';
import ADRModal from '../../components/modals/ADRModal.vue';
import DailyDosesModal from '../../components/modals/DailyDosesModal.vue';
import AdhocReadingModal from '../../components/modals/AdhocReadingModal.vue';
import ReadingsModal from '../../components/modals/ReadingsModal.vue';
import ConfirmationModal from '../../components/modals/ConfirmationModal.vue';
import SignatureModal from '../../components/modals/SignatureModal.vue';
import { isBeforeToday } from '@/services/dates';
import { isTokenExpired, errorMessage } from '@/utils/errors';

export default {
    components: {
        PatientInfo,
        PatientBanner,
        PatientMedicationTable,
        // PatientExpandModal,
        ChartExpansion,
        PatientMedicationHistory,
        PrescriptionChart,
        PrescriberNIMSelect,
        SpecialConsiderations,
        Files,
        MyHealthRecorModal,
        MiniViewMhr,
        ADRModal,
        DailyDosesModal,
        AdhocReadingModal,
        ReadingsModal,
        ConfirmationModal,
        SignatureModal
    },
    data() {
        return {
            openMhrMiniView: false,
            displayADRModal: false,
            displayDailyDosesModal: false,
            selectedAdhocReading: null,
            displayReadingsModal: false,
            adhocReadingOptions: [
                {label: 'Sedation Score', value: 'sedation'},
                {label: 'INR Reading', value: 'inr'},
                {label: 'Blood Glucose', value: 'bgl'},
                {label: 'Serum Creatinine', value: 'creatinine'}
            ],
            displayAdhocReadingModal: false,
            displayCeaseChartModal: false,
            displayCeaseReasonModal: false,
            ceaseChartReason: '',
            // Signature capture for /cease-chart - a single (primary) signature only, there is
            // never a witness signature for a chart cease/cancellation.
            displayCeaseSignatureModal: false,
            ceaseChartPayload: null,
            dailyDoses: [],
            loadingDailyDoses: false,
            displayPrescription: false,
            refreshingPatientReadings: false,
            forceNoErx: false,
            reviewedPrescriptions: [
                //   "f9ab5e13-9cc6-4a27-a274-6fbb85a1289a"
            ],
            loadingCharts: false,
            drugs: [],
            routes: [],
            types: [],
            typeOptions: [],
            frequencies: [],
            infoADRTab: 'ADR',
            selectedTab: 'medications',
            expandModal: false,
            //   displayMedicationHistoryModal: false,
            displayedChartId: '',
            expandedChartDetails: {},
            displayExpansion: false,
            modalTitle: 'Primary General Practitioner',
            tableData: null,
            //   this is a string grouping of all the types of charts this patient has
            patientChartTypes: [],
            //   this is the object grouping of all chart types incl name and color
            chartGroups: [],
            drugNames: [],
            registerData: [],
            date: [],
            clearForm: {
                name: '',
                location: this.$store.state.uuid,
                page: 1
            },
            charts: [],
            expiredCharts: [],
            patient: '',

            //   patient:'',
            form: {
                patient_id: null,
                location: this.$store.state.uuid,
            },
            medicare: '',
            dva: '',
            concession: '',
            spec_cons:[],
            facility_id: '',
            facility: '',
            activeCharts:null,
            triggerUploadFile:false,
            uploadFileStatus:false,
            loadingMhr:false,
            mhrError:'',
            mhrSuccess: false,
            supersedeFile:null,
            ihiDetails: null,
            patientUUID: '',
            nextInrTestDate: null,
            savingInrTestDate: false,
        }
    },
    methods: {
       updateNextInrTestDate(newDate) {
           if (!newDate) return;
           this.savingInrTestDate = true;
           
           const year = newDate.getFullYear();
           const month = String(newDate.getMonth() + 1).padStart(2, '0');
           const day = String(newDate.getDate()).padStart(2, '0');
           const formattedDate = `${year}-${month}-${day}`;
           
           const payload = { next_inr_test: formattedDate };
           axios.post('/patient/' + this.patient.uuid + '/add-test', payload, this.$store.state.header)
                .then(res => {
                    this.patient.next_inr_test = formattedDate;
                    this.$toast.add({severity: 'success', summary: 'Success', detail: 'Next INR test date updated', life: 3000});
                })
                .catch(err => {
                    console.error('Failed to update next INR test date', err);
                    this.$toast.add({severity: 'error', summary: 'Error', detail: 'Failed to update next INR test date', life: 3000});
                })
                .finally(() => {
                    this.savingInrTestDate = false;
                });
       },
       openAdhocReadingModal() {
           if (this.selectedAdhocReading) {
               this.displayAdhocReadingModal = true;
           }
       },
       closeAdhocReadingModal() {
           this.displayAdhocReadingModal = false;
           this.selectedAdhocReading = null;
       },
       handleAdhocReadingCompleted(reading) {
           console.log("Adhoc reading completed", reading);
           this.closeAdhocReadingModal();
           this.$emit('updatePatientReading', reading);
       },
       viewDailyDoses() {
           this.displayDailyDosesModal = true;
           this.loadingDailyDoses = true;
           axios.post(`/patient/${this.$route.params.id}/daily-doses`, {}, this.$store.state.header).then(res => {
               this.dailyDoses = res.data;
               this.loadingDailyDoses = false;
           }).catch(err => {
               console.error('Error fetching daily doses:', err);
               this.loadingDailyDoses = false;
           });
       },
       closeMhrModal() {
            this.triggerUploadFile = false;
            this.mhrError='';
            this.mhrSuccess = false;
        },
        viewFMhrFile() {
            console.log("opening mhr modules, state ");
            this.openMhrMiniView=!this.openMhrMiniView;
        },
        uploadFile(supersedeFile,callback) {
            console.log("this is file will be supersede ......",supersedeFile);
            if (supersedeFile) {
                console.log("here");
                this.supersedeFile = supersedeFile;
            } else {
                this.supersedeFile = null;
            }
            this.triggerUploadFile = true;
            this.uploadFileStatus = true;
        },
        b64toBlob(b64Data, contentType = '', sliceSize = 512){
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize),
                    byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        printRmc(){
            axios.post('/generate-pdf/charts', { patient_id: this.patient.uuid, location: this.$store.state.currentLocation.uuid }, this.$store.state.header)
                .then(async res => {
                    let linkSource = res.data.body;
                    if (typeof linkSource === 'string') {
                        linkSource = linkSource.replace(/"/g, '');
                    }
                    let blob = this.b64toBlob(linkSource, "application/pdf");
                    
                    let filename = this.patient?.personal_information?.first_name && this.patient?.personal_information?.last_name ? this.patient.personal_information.first_name + " " + this.patient.personal_information.last_name : "Resident";
                    const pdfTitle = filename + "_Medication_Chart.pdf";

                    const objectUrl = URL.createObjectURL(blob) + '#filename=' + encodeURIComponent(pdfTitle);
                    
                    const originalTitle = document.title;
                    document.title = pdfTitle;

                    const iframe = document.createElement('iframe');
                    iframe.title = pdfTitle;
                    iframe.name = pdfTitle;
                    iframe.style.position = 'fixed';
                    iframe.style.top = '0';
                    iframe.style.left = '0';
                    iframe.style.width = '100vw';
                    iframe.style.height = '100vh';
                    iframe.style.opacity = '0';
                    iframe.style.pointerEvents = 'none';
                    iframe.style.zIndex = '-9999';
                    iframe.style.border = '0';
                    iframe.src = objectUrl;
                    
                    iframe.onload = function() {
                        iframe.onload = null;
                        setTimeout(() => {
                            iframe.contentWindow.print();
                        }, 1500);
                        setTimeout(() => {
                            document.title = originalTitle;
                            if (document.body.contains(iframe)) {
                                document.body.removeChild(iframe);
                            }
                            URL.revokeObjectURL(objectUrl);
                        }, 10000);
                    };
                    
                    document.body.appendChild(iframe);
                    this.loadingMhr = false;
                    this.triggerUploadFile = false;
                })
                .catch(err => {
                    // Was `this.mhrError = err`, which rendered the axios Error object as
                    // "[object Object]".
                    this.mhrError = errorMessage(err);
                    if (isTokenExpired(err)) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                })
        },
        uploadFileHandler(action) {
            if (this.mhrSuccess) {
                this.closeMhrModal();
                return;
            }
            this.loadingMhr = true;
            if (action.type === "print") {
                console.log('printing files .....patient :',this.patient);
                this.$store.dispatch('getRefreshToken');
                this.printRmc();
                return;
            } else {
                this.$store.dispatch('getRefreshToken');
            console.log('uploading files .....patient :',this.patient);
            // if (!this.patient.personal_information.ihi || !this.patient.address) {
            //     this.uploadFileStatus = false;
            //         this.loadingMhr=false;
            //         this.mhrError = "Patient have no address or Ihi";
            //         this.$store.dispatch('triggerUploadSuccess', true);
            //         console.log("Patient have no address or Ihi");
            //     return;
            // }
                let req = {
                    document: "",
                    supersede_document_id: action.file || null
                };
                req.patient = {
                    ihi: null
                };
                console.log("this is req ", req);
                  // Add new field to header without mutating the original
                  const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Facility': this.patient.physical_location.location.facility.uuid
                    }
                };
                axios.post(`/mhr/patient/${this.patient.uuid}/upload-file`, req, enhancedHeader).then(res => {
                    console.log("this is uploading file res: ...... ,", res.data);
                    if (res.data && res.data.errors) {
                        this.uploadFileStatus = false;
                        this.loadingMhr = false;
                        this.mhrSuccess = false;
                        let errorMsg = 'An unexpected error occurred. Please try again.';
                        if (res.data.messages) {
                            if (Array.isArray(res.data.messages)) {
                                errorMsg = res.data.messages.join(', ');
                            } else if (typeof res.data.messages === 'string') {
                                errorMsg = res.data.messages;
                            } else {
                                errorMsg = JSON.stringify(res.data.messages);
                            }
                        }
                        this.mhrError = errorMsg;
                        this.$store.dispatch('triggerUploadSuccess', true);
                        return;
                    }
                    // this.printRmc();
                    this.loadingMhr = false;
                    this.uploadFileStatus = false;
                    this.mhrSuccess = true;
                    this.$store.dispatch('triggerUploadSuccess', true);
                }).catch(err => {
                    this.uploadFileStatus = false;
                    this.loadingMhr = false;
                    this.mhrSuccess = false;
                    
                    let errorMsg = 'An unexpected error occurred. Please try again.';
                    if (err.response && err.response.data) {
                        const data = err.response.data;
                        if (data.error && data.error.message) {
                            try {
                                const parsedMessage = JSON.parse(data.error.message);
                                if (parsedMessage.errors) {
                                    const firstKey = Object.keys(parsedMessage.errors)[0];
                                    if (firstKey && parsedMessage.errors[firstKey] && parsedMessage.errors[firstKey].length > 0) {
                                        errorMsg = parsedMessage.errors[firstKey][0];
                                    } else {
                                        errorMsg = parsedMessage.message || data.error.message;
                                    }
                                } else {
                                    errorMsg = parsedMessage.message || parsedMessage.error || data.error.message;
                                }
                            } catch (e) {
                                errorMsg = data.error.message;
                            }
                        } else if (data.message) {
                            errorMsg = data.message;
                        } else if (typeof data === 'string') {
                            errorMsg = data;
                        } else {
                            errorMsg = JSON.stringify(data);
                        }
                    } else if (err.message) {
                        errorMsg = err.message;
                    }
                    this.mhrError = errorMsg;

                    this.$store.dispatch('triggerUploadSuccess', true);
                    console.log("Error catch /upload-file ,", err);
                    if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.split(' ').includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                })
            }
      
        },
        removeExpiredCharts(value){
            if(value){
                console.log('removing these expiring charts for chart review', this.charts.filter((chart, index)=>{return !chart.expired}))
                this.charts = this.charts.filter((chart, index)=>{return !chart.expired})
            }
        },
        dismissExpiredChart(value){
            console.log('hitting the dismiss expired chart', value);
            console.log('received dismiss expired chart request', value, this.charts.length);
            this.charts = this.charts.filter((chart, index)=>value!=index);
            this.charts[value].display = false;
            document.getElementById(`expand-${value}`).style.display = 'none';
            console.log('these are the new charts post-splice', this.charts.length);
            this.expiredCharts = this.expiredCharts.filter((chart,index)=>value!=index)
        },
        changeStatus(value){
            console.log('receiving the res status in pat general', value);
            if(value && this.patient){
                console.log('changing the res status in pat general', value);
                this.patient.status = value.slice(0,1).toUpperCase()+value.slice(1);
            }
        },
        async displayPrescriptionForm(value, options = {}){
            if(!value){
                return;
            }
            // Ignore re-entrant clicks while the pre-open refresh is in flight.
            if(this.refreshingPatientReadings){
                return;
            }
            this.forceNoErx = options && options.noErx ? true : false;
            // Await the refresh rather than letting it land after the form renders: the
            // warfarin/INR panel reads patient.latest_inr_reading for both the displayed value
            // and the acknowledged_reading_id it submits, so a mid-flight swap would change
            // which reading gets signed underneath the prescriber.
            this.refreshingPatientReadings = true;
            try {
                await this.refreshPatientReadings();
            } finally {
                this.refreshingPatientReadings = false;
                // Always open, even if the refresh failed - prescribing must not be blocked by
                // it; refreshPatientReadings has already warned that values may be stale.
                this.displayPrescription = true;
            }
        },
        /**
         * Re-fetch the patient and patch ONLY the reading-derived fields onto the existing
         * patient object.
         *
         * Deliberately not getPatient(): that replaces the patient wholesale and additionally
         * fires getBasicInfo/getFacilityInfo/getIHI, and getIHI can raise the IHI conflict
         * modal - which must not appear on top of the prescribing form.
         */
        async refreshPatientReadings(){
            if(!this.patient || !this.form.patient_id){
                return;
            }
            try {
                const res = await axios.post('/retrieve-patient', this.form, this.$store.state.header);
                const fresh = res.data;
                // Guard against a response for a different resident (route changed mid-flight).
                if(!fresh || !fresh.uuid || fresh.uuid !== this.patient.uuid){
                    return;
                }
                this.patient.latest_inr_reading = fresh.latest_inr_reading;
                this.patient.latest_creatinine_reading = fresh.latest_creatinine_reading;
                this.patient.latest_height_reading = fresh.latest_height_reading;
                this.patient.latest_weight_reading = fresh.latest_weight_reading;
                this.patient.readings = fresh.readings;
                this.patient.next_inr_test = fresh.next_inr_test;
            } catch (err) {
                console.error('Failed to refresh readings before prescribing', err);
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Readings not refreshed',
                    detail: 'Could not confirm the latest readings - the values shown may be out of date.',
                    life: 5000
                });
            }
        },
        addingToReview(value) {
            if (value) {
                this.reviewedPrescriptions.push(value.prescription_id);
                this.reviewedPrescriptions = this.reviewedPrescriptions.filter((v, i, a) => a.indexOf(v) === i);
                console.log('ADDED TO PRESCRIPTION REVIEW', this.reviewedPrescriptions);
            }
        },
        removingFromReview(value) {
            if (value) {
                this.reviewedPrescriptions.splice(this.reviewedPrescriptions.indexOf(value), 1);
                console.log('REMOVED FROM REVIEW', this.reviewedPrescriptions);
            }
        },
        emptyReviewPrescription(value) {
            if (value) {
                this.reviewedPrescriptions = [];
                console.log('EMPTYING REVIEW PRESCRIPTIONS', this.reviewedPrescriptions);
            }
        },
        signChart(value) {
            this.charts[value].signNow = true;
            console.log('this is the chart from sign chart', this.charts[value]);
        },
        getAdministration(value) {
            console.log('this is the administration request uuid', this.charts[value].uuid);
            
            axios.post(`/prescription/${this.charts[value].uuid}/administrations`, { include_deleted: true }, this.$store.state.header).then(res=>{
                console.log('this is the res for the chart admin history', res);
                this.charts[value].administration = res.data;
            })
        },
        updateChartHeight(value) {
            this.chart[value.index].checkHeight = true;
            console.log('hitting the patient general emit updatechartheight', value);
        },
        selectTab(tab) {
            this.selectedTab = tab;
            if (tab === 'medications') {
                this.getPatient();
            }
        },
        displayChartGroupItems(chartType) {
            console.log(chartType);
        },
        searchPatients() {
            this.$store.dispatch('searchPatients', this.form).then(res => {
                console.log('these are the returning patients', res.data);
            })
        },
        close(value) {
            if (value) {
                this.expandModal = false;
                this.displayMedicationHistoryModal = false;
            }
            console.log('getting close to the general');
        },
        openModal(displayContent) {
            this.expandModal = true;
            this.modalTitle = displayContent;
            console.log('this is the computed primary gp', this.getPrimary[0]);
            switch (displayContent) {
                case 'Primary General Practitioner':
                    this.tableData = [{
                        name: this.getPrimary[0].name,
                        address: this.getPrimary[0].address,
                        phone: this.getPrimary[0].phone,
                        after_hours: this.getPrimary[0].after_hours,
                        fax: this.getPrimary[0].fax,
                        email: this.getPrimary[0].email,
                        prescriber_no: this.getPrimary[0].prescriber_no
                    }];
                    break;

                case 'Pharmacy':
                    this.tableData = [this.patient.pharmacy];
                    break;
                // case 'All Prescribers (not primary GP)':
                //     this.tableData = this.getPrescribers;
                //     break;

            }
        },
        getFilterValues() {
            console.log('GOING THROUGH FILTER VALUES')
            this.types = this.types.filter((v, i, a) => a.indexOf(v) === i);

            let chartTypes = this.$store.getters.getChartTypes;
            this.types.forEach(type => {
                chartTypes.forEach(chartType => {
                    if (type == chartType.chart_name) {
                        this.typeOptions.push(chartType);
                        console.log('this is the list of TYPES', this.typeOptions);
                    }
                })
            })
        },
        remapPresChart(value) {
            console.log('remapping data', value);
            value.activePresChart = {};

            let formatted_dose_times = [];
            if (value.dose_times && Array.isArray(value.dose_times)) {
                value.dose_times.forEach((dt) => {
                    // Check if it's the newer formatted data with 'times' array
                    if (dt.times && Array.isArray(dt.times)) {
                        formatted_dose_times.push({
                            day: dt.day !== undefined ? dt.day : null,
                            times: dt.times,
                        });
                    } 
                    // Otherwise check the old flat format
                    else if (dt.time?.length) {
                        formatted_dose_times.push(dt);
                    } else if (dt.uuid) {
                        formatted_dose_times.push({
                            uuid: dt.uuid,
                            time: dt.times,
                            qty: dt.dose ? dt.dose.toString() : '',
                            date: dt.date ? dt.date : ''
                        });
                    }
                });
            }

            // explicitly mapping all datapoints in case of any object changes from the response value

            value.activePresChart = {
                chart_payload: {
                    prescription_id: value.uuid,
                    chart_form: {
                        type: value.chart_type,
                        route: value.route,
                        indication: value.indication,
                        tags: []
                    }
                },
                prescription_payload: {
                    scheduled: value.alias && value.alias.tags && value.alias.tags.includes('S8') ? true : false,
                    patient_id: this.$route.params.id,
                    prescriber: value.doctor?.uuid ? value.doctor?.uuid : '',
                    drug_uuid: value.alias?.alias_id ? value.alias.alias_id : '',
                    substitution_not_permitted: value.substitution_not_permitted ? true : false,
                    chart_id: value.chart_id,
                    authority_prescription_number: value.authority_prescription_number ? value.authority_prescription_number  : '',
                    pbs_code: value.pbs_code ? value.pbs_code  : '',
                    pbs_manufacturer_code: value.pbs_manufacturer_code ? value.pbs_manufacturer_code  : '',
                    pbs_authority_code: value.pbs_authority_code ? value.pbs_authority_code  : '',
                    days_of_week: value.days_of_week,
                    interval: value.interval,
                    num_repeats_authorised: value.num_repeats_authorised,
                    repeat_interval: value.repeat_interval,
                    frequency: value.frequency,
                    frequency_shorthand: value.frequency_shorthand,
                    times: value.times,
                    dose: value.dose,
                    dose_unit: value.dose_unit,
                    route: value.route,
                    sliding_scale: value.sliding_scale,
                    max_admin_dose: value.max_admin_dose,
                    max_daily_admin: value.max_daily_admin,
                    is_paper: value.is_paper ? true : false,
                    paper_prescription_number : value.paper_prescription_number ? value.paper_prescription_number : value.is_paper ? '1' : '',
                    reason: value.reason,
                    max_dose: value.max_dose,
                    start_date: value.start_date ? new Date(value.start_date).toLocaleDateString('en-AU') : '',
                    stop_date: value.stop_date ? new Date(value.stop_date).toLocaleDateString('en-AU') : '',
                    additional_regulatory_checks: '',
                    administrations: value.administrations,
                    // created_date: !isNaN(Date.parse(value.created_at)) ? new Date(value.created_at).toLocaleDateString('en-AU') : '' ,
                    created_date: value.created_at ? new Date(value.created_at).toLocaleDateString('en-AU') : '',
                    dose_times : formatted_dose_times,
                    last_administration: value.last_administration ? value.last_administration  :'',
                    administration_history: value.administration ? value.administration : '',
                    prescribed_quantity: value.prescribed_quantity,
                    notes: value.instructions && value.instructions.text ? value.instructions.text : '',
                    chart_tags: value.chart_tags,
                    signed: value.signatures && value.signatures.length ? true : false,
                    pbs_type: value.pbs_type,
                    aslr_consent: value.aslr_consent ? true : false,
                    privacy_statement: value.privacy_statement ? true : false,
                    ctg: value.ctg ? true : false,
                    is_extemp: value.is_extemp ? true : false,
                    consent: value.consent ? value.consent : null,
                    pack_size: value.pack_size,
                    prescribed_pack_size_id: value.prescribed_pack_size_id,
                    prescribed_ctpp_id: value.prescribed_ctpp_id,
                    erx_status: value.erx_status,
                    erx_ceased: value.erx_ceased,
                    dismissed: value.is_dismissed,
                    rx_chart_order: value.rx_chart_order,
                    is_lemi: value.is_lemi ? true : false
                }
            };
            console.log("created at to created date", value.activePresChart.prescription_payload.created_date);
            console.log("created at to created date before conversion", value.created_at);
            value.draftDrug = value.alias;
            // if(!value.signatures && !value.signatures.length){
            //     value.isDraft = true;
            // } else{
            //     value.isDraft = false;
            // }
            console.log('received this from the table', value);
        },
        retrieveAllCharts(filters, noExpiredCharts) {
            this.requiringAction = 0;
            this.frequencies = [];
            this.drugs = [];
            this.types = [];
            this.routes = [];
            let payload = { ...filters };
            let chartTypes = this.$store.getters.getChartTypes;
            this.loadingCharts = true;
            console.log('calling prescriptions from retrieveallcharts');
            this.charts = null;
            this.expiredCharts = [];
            this.patientChartTypes = [];
            this.chartGroups = [];

            const processCharts = (charts, isExpiredSource = false) => {
                charts.forEach(chart => {
                    if (chart.signatures && chart.signatures.length) {
                        chart.nurse_signatures = [];
                        chart.prescriber_signed = false;
                        chart.signatures.forEach((signature) => {
                            if (signature.user_type == 'prescriber') {
                                chart.prescriber_signed = true;
                            } else {
                                if (signature.user_type == 'nurse' || signature.user_type == 'clinician') {
                                    signature.class = 'orange-tag'
                                    if (signature.type == 'primary') {
                                        signature.class = 'green-tag';
                                        chart.nurse_primary = signature;
                                    } else {
                                        if (signature.type == 'witness') {
                                            chart.nurse_witness = signature;
                                        }
                                        chart.nurse_signatures.push(signature);
                                    }
                                }
                            }
                        })
                    }

                    let b = new Date(chart.start_date).toLocaleDateString('en-AU');
                    let c = new Date(chart.stop_date).toLocaleDateString('en-AU');
                    chart.dateRange = `${b} - ${c}`

                    let today = new Date();
                    today.setHours(0, 0, 0, 0);

                    if (isExpiredSource || chart.expiring_in === 'Expired' || (new Date(chart.stop_date) < today)) {
                        chart.expired = true;
                    }

                    chartTypes.forEach(chartType => {
                        if ((chart.chart_type == chartType.chart_name) || (chart.chart_type == chartType.name)) {
                            chart.chart_type = chartType.chart_name;
                            chart.type = chartType.chart_name;
                            chart.color = chartType.color;
                            chart.chart_name = chartType.name;
                            chart.selectedChart = chartType;
                        }
                    })

                    if (!isExpiredSource) {
                        this.drugs.push(chart.alias.name);
                        this.frequencies.push(chart.frequency);
                        this.types.push(chart.chart_type);
                        this.routes.push(chart.route);
                        this.patientChartTypes.push(chart.type);
                        this.chartGroups.push(chart.selectedChart);

                        if (!chart.prescriber_signed) {
                            this.requiringAction += 1;
                        }
                    }
                });
                return charts;
            };

            const fetchActive = () => axios.post(`/person/${this.$route.params.id}/prescriptions`, { payload }, this.$store.state.header);
            const fetchExpired = () => axios.post(`/person/${this.$route.params.id}/non-dismissed-expired-prescriptions`, {}, this.$store.state.header);
            const fetchData = () => {
                if (this.patient.erx_chart) {
                    // New patient logic: trust consolidated endpoint
                    return fetchActive().then(res => {
                        let allProcessed = processCharts(res.data.data);
                        
                        if (noExpiredCharts) {
                            allProcessed = allProcessed.filter(c => !c.expired);
                        }

                        // Sorting logic: expired charts at the top
                        allProcessed.sort((a, b) => (b.expired ? 1 : 0) - (a.expired ? 1 : 0));

                        this.charts = allProcessed;
                        this.activeCharts = allProcessed.filter(c => !c.expired);
                        this.expiredCharts = allProcessed.filter(c => c.expired);
                        this.loadingCharts = false;
                        this.getFilterValues();
                        this.$store.dispatch('getRefreshToken');
                    }).catch(err => {
                        this.handleFetchError(err);
                    });
                } else {
                    // Existing patient logic: dual fetch with reconciliation
                    return Promise.all([
                        fetchActive(),
                        noExpiredCharts ? Promise.resolve({ data: { data: [] } }) : fetchExpired()
                    ]).then(([activeRes, expiredRes]) => {
                        const activeData = activeRes.data.data;
                        const expiredData = expiredRes.data.data.filter(item => item.signatures && item.signatures.length);

                        // Reconciliation logic
                        const activeUuids = new Set(activeData.map(c => c.uuid));
                        const uniqueExpired = expiredData.filter(item => {
                            if (activeUuids.has(item.uuid)) {
                                return false;
                            }
                            console.warn(`[DIVERGENCE] Prescription ${item.uuid} found in expired but not in unified endpoint.`);
                            return true;
                        });

                        const merged = [...processCharts(activeData), ...processCharts(uniqueExpired, true)];
                        
                        // Sorting logic: expired charts at the top
                        merged.sort((a, b) => (b.expired ? 1 : 0) - (a.expired ? 1 : 0));

                        this.charts = merged;
                        this.activeCharts = merged.filter(c => !c.expired);
                        this.expiredCharts = merged.filter(c => c.expired);

                        this.loadingCharts = false;
                        this.getFilterValues();
                        this.$store.dispatch('getRefreshToken');
                    }).catch(err => {
                        this.handleFetchError(err);
                    });
                }
            };

            fetchData();
        },
        handleFetchError(err) {
            console.error('Fetch error:', err);
            this.loadingCharts = false;
            if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.split(' ').includes('expired')) {
                this.$router.push('/login');
            }
        },
                

                
        dismissAllCharts(value){
            if(value){
                this.charts = this.activeCharts;
                this.expiredCharts = []
            }
        },
        getAge(dateString) {
            dateString = dateString.split('/')[1]+'/'+dateString.split('/')[0]+'/'+dateString.split('/')[2];
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            console.log('THIS IS THE AGE AND DATESTRING', age, dateString, new Date(dateString));
            console.log('THIS IS THE birthdate', birthDate);
            console.log('THIS IS THE birthdate', birthDate.getFullYear(), birthDate.getMonth());
            console.log('THIS IS THE today', today);
            console.log('THIS IS THE today', today.getFullYear(), today.getMonth());
            return age;
        },
        getFacilityInfo(){
            axios.post('/get-facility', {facility_id: this.facility_id}, this.$store.state.header).then(res => {
                this.facility = res.data;
                this.$store.dispatch('getRefreshToken');
                console.log('this is the facility data for retrieve patient', this.facility);
               
            }).catch(err => {
                console.log('this is the err', err);
                if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                    console.log('yes, it does include expired')
                    this.$router.push('/login');
                }
            })

        },
        getBasicInfo() {
            this.medicare = (this.patient.regulatory_information.filter(item => item.regulatory_type == 'Medicare Number'))[0];

            this.dva = (this.patient.regulatory_information.filter(item => item.regulatory_type == 'DVA Number'))[0];
            if (this.dva && this.dva.data && this.dva.data.includes('|')) {
                let parts = this.dva.data.split('|');
                this.dva.data = parts[0];
                let status = parts[1];
                if (status === 'DVAGold') status = 'DVA Gold';
                if (status === 'DVAWhite') status = 'DVA White';
                if (status === 'DVAOrange') status = 'DVA Orange';
                this.dva.regulatory_type = status;
            }

            this.concession = (this.patient.regulatory_information.filter(item => item.regulatory_type == 'Concession Number'))[0];
            console.log('this is the medicare number', this.medicare, this.dva, this.concession);
        },
        getIHI(){
            let uuid = this.patientUUID ? this.patientUUID : (this.patient ? this.patient.uuid : this.form.patient_id);
            if (!uuid) return;
            // A patient with no IHI gets a 400 with "No active IHI numbers for this
            // individual." - the normal case for most residents, not a failure. Without a
            // handler it surfaced as an unhandled rejection on every one of them.
            axios.post(`/person/${uuid}/ihi`, {}, this.$store.state.header).then(res=>{
                this.ihiDetails = res.data;
                if(res.data.conflicted){
                    this.displayIHIConflictModal = true;
                }
            }).catch(err=>{
                console.log('this is the error of the ihi call', err);
            })
        },
        getPatient(){
                    //    GET PATIENT DATA
                axios.post('/retrieve-patient', this.form, this.$store.state.header).then(res => {
                    this.patient = res.data;
                    this.$store.dispatch('getRefreshToken');
                    this.patient.personal_information.age = this.getAge(this.patient.personal_information.dob);
                    this.patient.personal_information.image = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMyn74IpFH6FKnyy1JRAL2UTgIsxdByOVUIA&usqp=CAU';
                    console.log('this is the res data for retrieve patient', res.data, this.patient);
                    if(this.patient.considerations && this.patient.considerations.length){
                        this.spec_cons = this.patient.considerations[this.patient.considerations.length -1]
                    }

                    this.facility_id = this.patient.physical_location?.location?.facility?.uuid;
                    this.patientUUID = this.patient.uuid;
                    this.getBasicInfo();
                    this.getFacilityInfo();
                    this.getIHI();
                }).catch(err => {
                    console.log('this is the err', err);
                    if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                })
        },

        ceaseChart() {
            this.displayCeaseReasonModal = true;
        },
        closeCeaseReasonModal() {
            // Dismissing without continuing - clear so it can't leak into a later,
            // unrelated cease-chart attempt.
            this.displayCeaseReasonModal = false;
            this.ceaseChartReason = '';
        },
        confirmCeaseReason() {
            this.displayCeaseReasonModal = false;
            this.displayCeaseChartModal = true;
        },
        confirmCeaseChart() {
            this.displayCeaseChartModal = false;
            // Cancelling/ceasing a chart may require a signature if it contains a controlled
            // (S8/S4) drug (see CeaseChartSignatureRule on the backend) - always route through
            // SignatureModal to capture it (harmless if not required) rather than posting
            // directly, since this endpoint previously never sent one at all.
            this.ceaseChartPayload = {
                erx_chart_id: this.patient.erx_chart.uuid,
                reason: this.ceaseChartReason,
                // Never dual-signature - there is never a witness signature for a cancellation.
                has_scheduled_items: false
            };
            this.displayCeaseSignatureModal = true;
        },
        handleCeaseChartSignatureClose(value) {
            this.displayCeaseSignatureModal = false;
            if (value) {
                this.$toast.add({severity:'success', summary: 'Success', detail: 'Chart ceased successfully', life: 3000});
                this.ceaseChartReason = '';
                this.getPatient();
            }
        },
        handleCeaseChartSignatureError(err) {
            console.error("Error ceasing chart:", err);
            // SignatureModal emits err.response.data directly, which may be a plain string
            // message or a Laravel validation error object ({ message, errors }).
            const detail = typeof err === 'string' ? err : (err && err.message ? err.message : 'Failed to cease chart');
            this.$toast.add({severity:'error', summary: 'Error', detail, life: 3000});
        },
        startChartReview() {
            this.selectedTab = 'medications';
            this.$nextTick(() => {
                if (this.$refs.medTable) {
                    this.$refs.medTable.chartReview = true;
                    this.$refs.medTable.chartReviewList();
                }
            });
        },
        handlePatientConsentUpdated(consentData) {
            console.log('Patient general handling consent update:', consentData);
            if (this.patient) {
                if (!this.patient.consent) {
                    this.patient.consent = {};
                }
                this.patient.consent.has_consented = consentData.has_consented;
                this.patient.consent.uuid = consentData.uuid;
            }
        }
    },
    mounted() {
        console.log('this is the route param', this.$route.params.id);
        this.form.patient_id = this.$route.params.id;
        const predefinedTab = this.$route.params.tab;
        // Match the Medications tab's own visibility rule - prescribers and pharmacists
        // see that tab without patient_admin_active, so they must land on it too.
        const canViewMedications = this.$store.state.user.patient_admin_active
            || this.$store.state.user.type == 'prescriber'
            || this.$store.state.user.type == 'pharmacist';
        if(!canViewMedications){
            this.selectedTab = 'patient_info';
        }
        // Truthiness, not != "": an absent optional param is '' from a path push but
        // undefined from a named push, and undefined would blank the whole body.
        if(predefinedTab) {
            this.selectedTab = predefinedTab;
        }
       this.getPatient();
    },
    computed: {
        getPatients() {
            return this.$store.getters.getPatients;
        },
        getPrimary() {
            return this.patient.prescribers.filter(item => item.primary_gp)
        },
        uniqueSpecCons(){
            let b = this.spec_cons &&  this.spec_cons.special_considerations ?  this.spec_cons.special_considerations : [];
            const set = new Set();
            const result = b.filter((o) => {
                if (set.has(o.name)) return false;
                set.add(o.name);
                return true;
            });
            return result;
        },
        isErxChartExpired() {
            return isBeforeToday(this.patient?.erx_chart?.end_date);
        }
        // getPrescribers() {
        //     return this.patient.prescribers.filter(item => !item.primary_gp)
        // }
    }
}
</script>


<style lang="scss">
@import "../../assets/css/main.scss";

.chart-expansion-item {
    text-align: left;
    justify-content: space-between;
    background-color: white;
    // padding: 5px 20px; 
    margin: 10px;
    // border-bottom: 2px solid #cacaca
}

.parent-tabs-container {
    h3 {
        cursor: pointer;
        font-size: 1em;
        margin: 0;
        background-color: #0870DC; //$strongblue;
        padding: 7px 20px;
        border-radius: 20px 20px 0 0;
        color: white;
        min-width: 150px;
    }
}

.selected-tab {
    background-color: white !important;
    color: #0870DC !important; //$strongblue !important;
}

.img-square {
  object-fit: cover; 
  object-position: center;
  height: 190px;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 5px;
}

.similar-name-tag-patient-general {
  display: block;
  background-color: #ff9800;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: bold;
  border: 2px solid white;
  width: fit-content;
  text-align: left;
}
</style>